export default "__VITE_ASSET__ymHJjaii__"